import React, { useState, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
// import Navbar from "./components/Header2";
import Footer from "./components/Footer";
import Preloader from "./components/Preloader";

import Navbar from "./components/demoNav";

function Layout() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // ✅ Fire Meta Pixel PageView on every route change
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      console.log("🔥 Meta Pixel PageView fired on:", location.pathname);
    }
  }, [location]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <>
          <Navbar />

          <Outlet />
          <Footer />
        </>
      )}
    </>
  );
}

export default Layout;
